import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconMountainSummit({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} clipPath="url(#mountain-summit_svg__a)"><path d="m6.25 23.25 7.61-12.08a1.12 1.12 0 0 1 1.78 0l7.61 12.08z" /><path d="m6.25 23.25-5.5.01 6-9 2.85 3.68M11.31 15.22l3.41 2.29 3.44-2.35M14.75 10.73V.74M14.75.74h7.19a.53.53 0 0 1 .47.3.55.55 0 0 1-.06.55L21.21 3a.53.53 0 0 0 0 .65l1.14 1.45a.54.54 0 0 1 .06.55.53.53 0 0 1-.47.3h-7.19" /></g><defs><clipPath id="mountain-summit_svg__a"><path fill="currentColor" d="M0 0h24v24H0z" /></clipPath></defs></svg></>;
}
export default IconMountainSummit;